export enum CmsCollectionEntryVersionDataTypeEnum {
  String = 1,
  Select = 2,
  Reference = 3,
}
